export default __webpack_public_path__ + "static/highlight-2-99d92e3ec78b4b4771e353bd4d1a08f1.svg";